import { NavLink, Navigate, Outlet } from 'react-router-dom'
import { useAdminAuth } from '../context/AdminAuthContext'

const NAV_ITEMS = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/tenants', label: 'Tenant' },
  { to: '/admin/audit', label: 'Audit Log' },
  { to: '/admin/metriche', label: 'Metriche' },
  { to: '/admin/piani', label: 'Limiti piano' },
  { to: '/admin/mapping-templates', label: 'Template mapping' },
]

const ROLE_COLORS: Record<string, string> = {
  superadmin: 'bg-purple-500/20 text-purple-300',
  support: 'bg-blue-500/20 text-blue-300',
  sales: 'bg-green-500/20 text-green-300',
}

export function AdminLayout() {
  const { isAdminAuthenticated, adminUser, logout } = useAdminAuth()

  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />
  }

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--km-bg-deep)' }}>
      {/* Sidebar */}
      <aside
        className="w-56 flex-shrink-0 flex flex-col border-r"
        style={{
          background: 'rgba(8,11,18,0.97)',
          borderColor: 'var(--km-border)',
        }}
      >
        {/* Logo area */}
        <div
          className="px-5 py-4 border-b"
          style={{ borderColor: 'var(--km-border)' }}
        >
          <div className="flex items-center gap-2">
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold text-white"
              style={{ background: 'var(--km-gradient-brand)' }}
            >
              K
            </div>
            <div>
              <div className="text-xs font-bold text-white tracking-widest leading-none">
                KOREMARGIN
              </div>
              <div className="text-[10px] font-medium tracking-wide mt-0.5" style={{ color: 'var(--km-primary)' }}>
                ADMIN
              </div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `block px-3 py-2 text-sm rounded-lg transition-colors ${
                  isActive ? 'text-white font-medium' : 'hover:bg-white/5'
                }`
              }
              style={({ isActive }) => ({
                color: isActive ? 'var(--km-text-primary)' : 'var(--km-text-secondary)',
                background: isActive ? 'rgba(99,102,241,0.15)' : undefined,
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* User footer */}
        <div
          className="px-4 py-3 border-t"
          style={{ borderColor: 'var(--km-border)' }}
        >
          {adminUser && (
            <div className="mb-2">
              <div className="text-xs font-medium truncate" style={{ color: 'var(--km-text-primary)' }}>
                {adminUser.email}
              </div>
              <span
                className={`inline-block mt-1 px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide ${ROLE_COLORS[adminUser.role] ?? 'bg-gray-500/20 text-gray-300'}`}
              >
                {adminUser.role}
              </span>
            </div>
          )}
          <button
            onClick={logout}
            className="w-full text-left text-xs px-2 py-1.5 rounded transition-colors hover:bg-white/10"
            style={{ color: 'var(--km-text-muted)' }}
          >
            Esci
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Topbar */}
        <header
          className="flex items-center justify-between px-6 py-3 border-b flex-shrink-0"
          style={{
            background: 'rgba(8,11,18,0.97)',
            borderColor: 'var(--km-border)',
          }}
        >
          <h1 className="text-sm font-semibold tracking-wider" style={{ color: 'var(--km-text-secondary)' }}>
            ADMIN PANEL
          </h1>
          <div className="text-xs" style={{ color: 'var(--km-text-muted)' }}>
            Koremargin Internal
          </div>
        </header>

        <main className="flex-1 overflow-y-auto px-6 py-6">
          <div className="max-w-6xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
